export const homePageBookData = (data) => {
  return {
    type: "HOME_PAGE_BOOK_DATA",
    payload: data,
  };
};
